var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 45 45"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19381",
  transform: "translate(-1284 -523)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 22.5,
  "data-name": "Ellipse 1554",
  transform: "translate(1284 523)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15193"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1292 531h30v30h-30z",
  "data-name": "Rectangle 6440"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 15188"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1316.699 544.06v4.851c0 4.851-1.94 6.791-6.791 6.791h-5.818c-4.851-.003-6.791-1.941-6.791-6.791v-5.821c0-4.851 1.94-6.791 6.791-6.791h4.851",
  "data-name": "Path 5217"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1312.822 544.06c-2.911 0-3.881-.97-3.881-3.88v-3.881l7.761 7.761Z",
  "data-name": "Path 5218"
}))))));
export { SvgDocument as ReactComponent };
export default __webpack_public_path__ + "static/media/document.5bd7b50d20982c0ed26c0d1177b8afff.svg";